export var SPOTTER_EUREKA_URL_PARAM_NAMES;
(function (SPOTTER_EUREKA_URL_PARAM_NAMES) {
    SPOTTER_EUREKA_URL_PARAM_NAMES["WORKSHEET"] = "worksheet";
    SPOTTER_EUREKA_URL_PARAM_NAMES["QUERY"] = "query";
    SPOTTER_EUREKA_URL_PARAM_NAMES["DATA_SOURCES"] = "dataSources";
    SPOTTER_EUREKA_URL_PARAM_NAMES["EXTERNAL_DATA_SOURCE_CONNECTED"] = "externalDatasourceConnected";
    SPOTTER_EUREKA_URL_PARAM_NAMES["WORKSHEET_ID"] = "worksheetId";
    SPOTTER_EUREKA_URL_PARAM_NAMES["PLAYGROUND"] = "playground";
    SPOTTER_EUREKA_URL_PARAM_NAMES["SPOTTER_DATA_SOURCE_DISCOVERY"] = "spotterDataSourceDiscovery";
    SPOTTER_EUREKA_URL_PARAM_NAMES["SORT_ORDER"] = "sortOrder";
    SPOTTER_EUREKA_URL_PARAM_NAMES["SORT_ON_TYPE"] = "sortOnType";
    SPOTTER_EUREKA_URL_PARAM_NAMES["PAGE"] = "page";
    SPOTTER_EUREKA_URL_PARAM_NAMES["OFFSET"] = "offset";
    SPOTTER_EUREKA_URL_PARAM_NAMES["SOURCE"] = "source";
    SPOTTER_EUREKA_URL_PARAM_NAMES["SEARCH_MODE"] = "searchMode";
    SPOTTER_EUREKA_URL_PARAM_NAMES["EXECUTE_SEARCH"] = "executeSearch";
    SPOTTER_EUREKA_URL_PARAM_NAMES["API_REQUEST_ID"] = "apiRequestId";
    SPOTTER_EUREKA_URL_PARAM_NAMES["SUGGESTED_QUESTION_ID"] = "suggestedQuestionId";
    SPOTTER_EUREKA_URL_PARAM_NAMES["AUTHOR"] = "author";
    SPOTTER_EUREKA_URL_PARAM_NAMES["TAG"] = "tag";
    SPOTTER_EUREKA_URL_PARAM_NAMES["TYPE"] = "type";
    SPOTTER_EUREKA_URL_PARAM_NAMES["EUREKA_REQUEST_ID"] = "eurekaRequestId";
    SPOTTER_EUREKA_URL_PARAM_NAMES["EUREKA_ANSWER_AC_SESSION_ID"] = "eurekaAnswerAcSessionId";
    SPOTTER_EUREKA_URL_PARAM_NAMES["EUREKA_URL"] = "eurekaUrl";
    SPOTTER_EUREKA_URL_PARAM_NAMES["FIXER_ANSWER_GEN_NO"] = "fixerAnswerGenNo";
    SPOTTER_EUREKA_URL_PARAM_NAMES["FIXER_ANSWER_AC_GEN_NO"] = "fixerAnswerAcGenNo";
    SPOTTER_EUREKA_URL_PARAM_NAMES["FEEDBACK_MODE"] = "feedbackMode";
    SPOTTER_EUREKA_URL_PARAM_NAMES["EUREKA_QUERY"] = "eurekaQuery";
    SPOTTER_EUREKA_URL_PARAM_NAMES["LOAD_EVENT"] = "loadEvent";
    SPOTTER_EUREKA_URL_PARAM_NAMES["TRAIN_MODE"] = "trainMode";
    SPOTTER_EUREKA_URL_PARAM_NAMES["WORKSHEET_NAME"] = "worksheetName";
    SPOTTER_EUREKA_URL_PARAM_NAMES["CONVERSATION_ID"] = "conversationId";
    SPOTTER_EUREKA_URL_PARAM_NAMES["EXECUTE_INITIAL_QUERY"] = "executeInitialQuery";
    SPOTTER_EUREKA_URL_PARAM_NAMES["FILE_TOKEN"] = "fileToken";
    SPOTTER_EUREKA_URL_PARAM_NAMES["IS_DEEP_ANALYSIS"] = "isDeepAnalysis";
})(SPOTTER_EUREKA_URL_PARAM_NAMES || (SPOTTER_EUREKA_URL_PARAM_NAMES = {}));
export const MASK_TEXT = 'MASKED';
export const SPOTTER_URL_PARAMETERS = {
    [SPOTTER_EUREKA_URL_PARAM_NAMES.QUERY]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.QUERY,
        description: 'query string used to search query, used for spotter and eureka',
        dataType: 'string',
        isSensitive: true,
    },
    [SPOTTER_EUREKA_URL_PARAM_NAMES.SUGGESTED_QUESTION_ID]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.SUGGESTED_QUESTION_ID,
        description: 'query string used to determine the user picked Suggested question id from home page search bar',
        dataType: 'string',
        isSensitive: true,
    },
    [SPOTTER_EUREKA_URL_PARAM_NAMES.EUREKA_QUERY]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.EUREKA_QUERY,
        isSensitive: true,
        dataType: 'string',
    },
    [SPOTTER_EUREKA_URL_PARAM_NAMES.EUREKA_URL]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.EUREKA_URL,
        isSensitive: true,
        description: 'Eureka search url used for redirecting the user from fullscreen view new tab back to the Eureka SRP',
        dataType: 'string',
    },
    [SPOTTER_EUREKA_URL_PARAM_NAMES.SPOTTER_DATA_SOURCE_DISCOVERY]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.SPOTTER_DATA_SOURCE_DISCOVERY,
        isSensitive: false,
        description: 'query string used to determine if user is on data discovery mode in spotter homepage flow',
        dataType: 'boolean',
    },
    [SPOTTER_EUREKA_URL_PARAM_NAMES.WORKSHEET]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.WORKSHEET,
        isSensitive: false,
        description: 'query string used to determine the worksheet id used for spotter homepage flow and eureka',
        dataType: 'string',
    },
    [SPOTTER_EUREKA_URL_PARAM_NAMES.DATA_SOURCES]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.DATA_SOURCES,
        isSensitive: false,
        description: 'query string used to determine the data sources ids used for Spotter. Array of the data sources ids used for Spotter',
        dataType: 'string',
    },
    [SPOTTER_EUREKA_URL_PARAM_NAMES.WORKSHEET_ID]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.WORKSHEET_ID,
        isSensitive: false,
        description: 'query string used to determine the worksheet id used for copilot and edge',
        dataType: 'string',
    },
    [SPOTTER_EUREKA_URL_PARAM_NAMES.EXTERNAL_DATA_SOURCE_CONNECTED]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.EXTERNAL_DATA_SOURCE_CONNECTED,
        isSensitive: false,
        description: 'query string used to determine if an external data source is connected for edge',
        dataType: 'boolean',
    },
    [SPOTTER_EUREKA_URL_PARAM_NAMES.PLAYGROUND]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.PLAYGROUND,
        isSensitive: false,
        description: 'query string used to determine if page is on playground(spotter) page',
        dataType: 'boolean',
    },
    [SPOTTER_EUREKA_URL_PARAM_NAMES.TAG]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.TAG,
        isSensitive: false,
        description: 'query string used to determine the tag filter values for object search',
        dataType: 'string',
    },
    [SPOTTER_EUREKA_URL_PARAM_NAMES.AUTHOR]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.AUTHOR,
        isSensitive: false,
        description: 'query string used to determine the author filter values for object search',
        dataType: 'string',
    },
    [SPOTTER_EUREKA_URL_PARAM_NAMES.SOURCE]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.SOURCE,
        isSensitive: false,
        description: 'query string used to determine if the search happened using query suggestions or using manually typed query',
        dataType: 'string',
        allowedValues: ['QUERY_SUGGESTION', 'TYPED'],
    },
    [SPOTTER_EUREKA_URL_PARAM_NAMES.PAGE]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.PAGE,
        isSensitive: false,
        description: 'query string used to determine the page no in object search',
        dataType: 'number',
    },
    [SPOTTER_EUREKA_URL_PARAM_NAMES.OFFSET]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.OFFSET,
        isSensitive: false,
        description: 'query string used to determine the search result offset in object search',
        dataType: 'number',
    },
    [SPOTTER_EUREKA_URL_PARAM_NAMES.SORT_ON_TYPE]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.SORT_ON_TYPE,
        isSensitive: false,
        description: 'query string used to determine the search result sorty by order',
        dataType: 'number',
        allowedValues: [
            'CREATED_MS',
            'IMPRESSIONS_OVERALL',
            'MODIFIED_MS',
            'SCORE',
            'TYPED',
        ],
    },
    [SPOTTER_EUREKA_URL_PARAM_NAMES.SORT_ORDER]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.SORT_ORDER,
        isSensitive: false,
        description: 'query string used to determine the search result sorty by order',
        dataType: 'number',
        allowedValues: ['ASCENDING', 'DESCENDING'],
    },
    [SPOTTER_EUREKA_URL_PARAM_NAMES.EXECUTE_SEARCH]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.EXECUTE_SEARCH,
        isSensitive: false,
        description: 'query string used to determine if search needs to be executed(for sage and object search',
        dataType: 'boolean',
    },
    [SPOTTER_EUREKA_URL_PARAM_NAMES.API_REQUEST_ID]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.API_REQUEST_ID,
        isSensitive: false,
        description: 'query string used to determine the pass GetEurekaResults search request id to other pages',
        dataType: 'boolean',
    },
    [SPOTTER_EUREKA_URL_PARAM_NAMES.TYPE]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.TYPE,
        isSensitive: false,
        description: 'query string used to determine the filter values of search results type',
        dataType: 'boolean',
        allowedValues: ['ALL', 'ANSWER', 'PINBOARD'],
    },
    [SPOTTER_EUREKA_URL_PARAM_NAMES.EUREKA_REQUEST_ID]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.EUREKA_REQUEST_ID,
        isSensitive: false,
        description: 'query string used to determine the GetEurekaResults search request id that is passed as a query string. this is only used for edit/fixer mode of the nls sage. can be deprecated after nls sage deprecation',
        dataType: 'string',
    },
    [SPOTTER_EUREKA_URL_PARAM_NAMES.EUREKA_ANSWER_AC_SESSION_ID]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.EUREKA_ANSWER_AC_SESSION_ID,
        isSensitive: false,
        description: 'query string used to determine the nls sage answer ac session id that is passed as a query string. this is only used for edit/fixer mode of the nls sage. can be deprecated after nls sage deprecation',
        dataType: 'string',
    },
    [SPOTTER_EUREKA_URL_PARAM_NAMES.FIXER_ANSWER_GEN_NO]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.FIXER_ANSWER_GEN_NO,
        isSensitive: false,
        description: 'query string used to determine the nls sage answer session gen no that is passed as a query string. this is only used for edit/fixer mode of the nls sage. can be deprecated after nls sage deprecation',
        dataType: 'string',
    },
    [SPOTTER_EUREKA_URL_PARAM_NAMES.FIXER_ANSWER_AC_GEN_NO]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.FIXER_ANSWER_AC_GEN_NO,
        isSensitive: false,
        description: 'query string used to determine the nls sage answer ac session gen no that is passed as a query string. this is only used for edit/fixer mode of the nls sage. can be deprecated after nls sage deprecation',
        dataType: 'number',
    },
    [SPOTTER_EUREKA_URL_PARAM_NAMES.FEEDBACK_MODE]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.FEEDBACK_MODE,
        isSensitive: false,
        description: 'query string used to determine if user is on nls sage answer fixer mode/edit mode. this is only used for edit/fixer mode of the nls sage. can be deprecated after nls sage deprecation',
        dataType: 'boolean',
    },
    [SPOTTER_EUREKA_URL_PARAM_NAMES.LOAD_EVENT]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.LOAD_EVENT,
        isSensitive: false,
        description: 'query string used for firing mixpanel event when user clicks on search result in object search',
        dataType: 'string',
    },
    [SPOTTER_EUREKA_URL_PARAM_NAMES.TRAIN_MODE]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.TRAIN_MODE,
        isSensitive: false,
        description: 'query string used to determine if user is in spotter training mode.',
        dataType: 'boolean',
    },
    [SPOTTER_EUREKA_URL_PARAM_NAMES.SEARCH_MODE]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.SEARCH_MODE,
        isSensitive: false,
        description: 'query string used to determine the search mode for the search bar. This is not used anymore. Should be removed',
        dataType: 'string',
        allowedValues: ['_', ''],
    },
    [SPOTTER_EUREKA_URL_PARAM_NAMES.WORKSHEET_NAME]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.WORKSHEET_NAME,
        isSensitive: false,
        description: 'Worksheet name required for populating data source selector',
        dataType: 'string',
    },
    [SPOTTER_EUREKA_URL_PARAM_NAMES.CONVERSATION_ID]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.CONVERSATION_ID,
        isSensitive: false,
        description: 'Convex conversation ID to resume an existing conversation',
        dataType: 'string',
    },
    [SPOTTER_EUREKA_URL_PARAM_NAMES.EXECUTE_INITIAL_QUERY]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.EXECUTE_INITIAL_QUERY,
        isSensitive: false,
        description: 'When true, skips loadPastConversation and fires the initial query immediately',
        dataType: 'boolean',
    },
    [SPOTTER_EUREKA_URL_PARAM_NAMES.FILE_TOKEN]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.FILE_TOKEN,
        isSensitive: false,
        description: 'File upload token passed to Spotter page for initial file attachments',
        dataType: 'string',
    },
    [SPOTTER_EUREKA_URL_PARAM_NAMES.IS_DEEP_ANALYSIS]: {
        name: SPOTTER_EUREKA_URL_PARAM_NAMES.IS_DEEP_ANALYSIS,
        isSensitive: false,
        description: 'When true, enables deep analysis mode on Spotter',
        dataType: 'boolean',
    },
};
export const urlQueryParams = { ...SPOTTER_URL_PARAMETERS };
function maskUrlSearchParams(urlSearchParams) {
    urlSearchParams.forEach((_v, paramKey) => {
        if (urlQueryParams[paramKey]?.isSensitive) {
            urlSearchParams.set(paramKey, MASK_TEXT);
        }
    });
    return decodeURIComponent(urlSearchParams.toString());
}
export function maskQueryParamsOnUrl(url) {
    const urlObj = new URL(url);
    const searchParams = new URLSearchParams(urlObj.search);
    const onlyHash = urlObj.hash.split('?')[0];
    const queryParamsInHash = new URLSearchParams(urlObj.hash.split('?')[1]);
    const searchStr = maskUrlSearchParams(searchParams);
    const queryStrInHash = maskUrlSearchParams(queryParamsInHash);
    urlObj.search = searchStr;
    if (onlyHash && queryStrInHash)
        urlObj.hash = `${onlyHash}?${queryStrInHash}`;
    return decodeURIComponent(urlObj.toString());
}
export function maskQueryParamsOnRelativePath(relativePath) {
    const [onlyPath, searchStr] = relativePath.split('?');
    const searchParams = new URLSearchParams(searchStr);
    const maskedSearchStr = maskUrlSearchParams(searchParams);
    return maskedSearchStr ? `${onlyPath}?${maskedSearchStr}` : onlyPath;
}
//# sourceMappingURL=url-query-param.js.map